import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useFormikContext } from "formik";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import withAuth from "../../../../../../../Hoc/withAuth";
import { useState } from "react";

const LinkCampaigns = ({ name, user }) => {
  // Get Formik's state and methods
  const { values, setFieldValue } = useFormikContext();

  const token = user.token;
  const config = { headers: { Authorization: `Bearer ${token}` } };

  const [page] = useState(0);
  const [rowsPerPage] = useState(20);
  let S = values ? "&search=" + values.search : "";
  let P = rowsPerPage ? rowsPerPage : 1000;
  let PA = page ? page : 0;

  // Fetch ALL campaigns from the API
  const { data: queryData, isLoading } = useQuery({
    queryKey: ["all-call-centre-campaigns"],
    queryFn: async () =>
      await axios.get(
        `${process.env.REACT_APP_API_URL}/callCentre/campaigns?pageNumber=${PA}&limit=${P}${S}`,
        config
      ),
  });

  const allCampaigns = queryData?.data?.data?.rows || [];

  const linkedCampaignIds = values[name] || [];

  const selectedCampaignObjects = allCampaigns.filter((campaign) =>
    linkedCampaignIds.includes(campaign.id)
  );

  if (isLoading) {
    return (
      <TextField
        label="Select Campaigns to Link"
        fullWidth
        disabled
        InputProps={{
          startAdornment: <CircularProgress size={20} />,
        }}
        value="Loading campaigns..."
      />
    );
  }

  return (
    <Autocomplete
      multiple
      id="link-campaigns-autocomplete"
      value={selectedCampaignObjects}
      options={allCampaigns}
      disableCloseOnSelect
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name || ""}
      onChange={(event, newValue) => {
        setFieldValue(
          name,
          newValue.map((campaign) => campaign.id)
        );
      }}
      style={{ width: "100%" }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Campaigns to Link"
          placeholder="Linked Campaigns"
        />
      )}
    />
  );
};

// You still need withAuth if it provides the user prop
export default withAuth(LinkCampaigns);
